import { render, staticRenderFns } from "./TrendComplementary.vue?vue&type=template&id=1cbe6c3e&name=trend-complementary&"
import script from "./TrendComplementary.vue?vue&type=script&lang=js&"
export * from "./TrendComplementary.vue?vue&type=script&lang=js&"
import style0 from "./TrendComplementary.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports